export const MAX_SIZE = 10 * 1024 * 1024; // 10 megabyte
export const MAX_FILE_SIZE = 1024 * 1024; // bytes
export const MAX_FLOOR_PLAN_SIZE = 5 * 1024 * 1024; // 5mb

const ALL_COLS = 12;
const HALF_COLS = 6;

export const getSmDropZone = (isTestImages) => {
  return isTestImages ? ALL_COLS : HALF_COLS;
};

export const getSmPreviewrContainer = (isTestImages) => {
  return isTestImages ? ALL_COLS : HALF_COLS;
};



// WEBPACK FOOTER //
// src/constants/FloorPlan.js